





















































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Route } from "vue-router";
import { ButtomData, ButtomItemData } from "../../stores/footer";

@Component({})
export default class Footer extends Vue {
  @Prop({
    default: null
  })
  dataRender: ButtomData;

  tab(item: ButtomItemData) {
    if (item.action) {
      item.action();
    }
    if (item.router) {
      this.$router.push(item.router);
    }
  }
}
